import React, { Component } from 'react'
import { compose, mapProps, branch, renderNothing } from 'recompose'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import { Icon } from '@driftt/tide-core-legacy'
import CompanyAvatar from "./CompanyAvatar"

import * as style from './style.styl'

import twitterIconSrc from '!svg-inline?removeTags=true!images/icons/twitter-logo.svg'
import linkedinIconSrc from '!svg-inline?removeTags=true!images/icons/linkedin.svg'

const TwitterHandle = ({ twitterHandle }) => {
  return (
    <a href={`https://twitter.com/${twitterHandle}`} target="_blank">
      <IconSVG className="social-icon" src={twitterIconSrc} />
    </a>
  )
}

const LinkedInHandle = ({ linkedInHandle }) => {
  return (
    <a href={`https://www.linkedin.com/${linkedInHandle}`} target="_blank">
      <IconSVG className="social-icon social-icon-linkedin" src={linkedinIconSrc} />
    </a>
  )
}

class Header extends Component {
  renderSocialIcons() {
    const {
      companyLinkedInHandle: twitterHandle,
      companyTwitterHandle: linkedInHandle,
    } = this.props

    if (!twitterHandle && !linkedInHandle) {
      return null
    }

    return (
      <span className="social-icons">
        {twitterHandle && <TwitterHandle twitterHandle={twitterHandle} />}
        {linkedInHandle && <LinkedInHandle linkedInHandle={linkedInHandle} />}
      </span>
    )
  }

  render() {
    const {
      className,
      conversationId,
      companyName,
      companyDomain,
      companyLogo,
      companyUrl,
    } = this.props

    return (
      <div className={cx(style.header, className, 'flex-row')}>
        <CompanyAvatar companyName={companyName} logoUrl={companyLogo} className="companyAvatar" />
        <div>
          {companyName && (
            <div className="name">
              {companyName}
            </div>
          )}
          {companyDomain && (
            <div className="domain">
              <a href={companyUrl || `http://www.${companyDomain}`} target="_blank">
                {companyDomain}
              </a>
            </div>
          )}
          <div className="flex-row action-links">
            {this.renderSocialIcons()}
          </div>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Company/Header/index.js